/* @flow */

import * as React from 'react';

import {Sidebar} from 'shells/sidebar';
import {LoadingPage} from 'shells/loading-page';

import {useGetMcfxCompany} from '../../graphql/hooks/use-get-mcfx-company';
import {SidebarContent} from './sidebar-content';

type Props = {
    visitorId: string,
    onClose: () => void,
};

export function VisitorsSidebar(props: Props) {
    const {mcfxCompany, isLoading} = useGetMcfxCompany(props.visitorId);

    return (
        <Sidebar
            isOpen={true}
            preventBodyScroll={false}
            canClickOutsideToClose={true}
            canEscapeToClose={true}
            onClose={props.onClose}
            isSaving={false}
        >
            {isLoading ? <LoadingPage padding={0} /> : undefined}
            {mcfxCompany ? (
                <SidebarContent
                    id={mcfxCompany.id}
                    name={mcfxCompany.name}
                    phone={mcfxCompany.phones[0]}
                    url={mcfxCompany.url}
                    address={mcfxCompany.primaryAddress}
                    industry={mcfxCompany.industry}
                    revenue={mcfxCompany.annualRevenue ? mcfxCompany.annualRevenue.amount : null}
                    numEmployees={mcfxCompany.numEmployees}
                    isLocked={mcfxCompany.isLocked}
                    convertedTime={mcfxCompany.convertedTime}
                    unlockTime={mcfxCompany.unlockTime}
                    lastSeenTime={mcfxCompany.lastSeenTime}
                    wasConvertedAutomatically={mcfxCompany.wasConvertedAutomatically}
                    relatedAccountPath={
                        mcfxCompany.relatedAccount
                            ? mcfxCompany.relatedAccount.htmlUrlPath
                            : undefined
                    }
                    numVisits={mcfxCompany.numVisits}
                    totalVisitDuration={mcfxCompany.totalVisitDuration}
                />
            ) : (
                undefined
            )}
        </Sidebar>
    );
}
